<template>
<!-- 单位工龄 -->
  <div class="txzl-wrap">
    <p>*您的信息仅展示给银行或持牌平台，未经您授权我们不会泄露您的信息*</p>
    <div class="txzl-wrap-title">
      <span>您在当前单位工龄多长？</span>
      <span @click="$router.go(-1)" v-if="loanNumber!== 1">上一步</span>
    </div>
    <div>
      <van-radio-group v-model="work_time" @change="goNext">
        <van-cell-group :border="false"> 
          <van-cell v-for="(items, index) in workData" :key="index" :title="items.text" :border="false" checked-color="#0294FF" @click="checkVlue(items.text_value)" clickable>
            <template #right-icon>
              <van-radio :name="items.text_value" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div class="btn-fixed" @click="goNext">
      <div class="loanbtn">
        <p>下一步({{loanNumber}}/{{infoData.param_total}})</p>
      </div>
    </div>
  </div>
</template>
<script>
import { CellGroup, Cell, Radio, RadioGroup, Button, Toast } from 'vant'
// import { mapState } from 'vuex'
export default {
  name: 'Danweigongling',
  data() {
    const work_time = JSON.parse(window.localStorage.getItem('loanParams')).work_time
    const infoData = JSON.parse(window.localStorage.getItem('infoData'))
    return {
      work_time: !!work_time ? work_time : '',
      workData: infoData.result.work_time.options,
      loanNumber: Number(this.$route.query.loanNumber),
      channel_lable: window.localStorage.getItem('channel'),
      loanBtnWidth: 0,
      infoData
    }
  },
  created() {
    this.loanBtnWidth = ((this.loanNumber-1)/Number(this.infoData.param_total))*100
  },
  methods: {
    checkVlue(value) {
      this.work_time = value
    },
    goNext() {
      if(!!this.work_time) {
        Toast.loading({
          message: '加载中...',
          forbidClick: true,
          loadingType: 'spinner',
        });
        let loanParams = JSON.parse(window.localStorage.getItem('loanParams'))
        loanParams['work_time'] = this.work_time
        window.localStorage.setItem('loanParams', JSON.stringify(loanParams))
        const loanNumber = this.loanNumber + 1
        this.$router.push('/loan/components/sebao?channel_lable='+ this.channel_lable+'&loanNumber='+ loanNumber) 
      }else {
        this.$toast('请选择')
      }
    }
  },
  components: {
    [Cell.name]: Cell,
    [Radio.name]: Radio,
    [CellGroup.name]: CellGroup,
    [RadioGroup.name]: RadioGroup,
    [Button.name]: Button
  }
}
</script>